import React, { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

const SCHRITTE = [
  { nr: 1, name: 'Übernahme' },
  { nr: 2, name: 'Ersatzteile' },
  { nr: 3, name: 'Demontage' },
  { nr: 4, name: 'Lackvorbereitung' },
  { nr: 5, name: 'Lackierung' },
  { nr: 6, name: 'Lackkontrolle' },
  { nr: 7, name: 'Montage' },
  { nr: 8, name: 'Politur' },
  { nr: 9, name: 'Aufbereitung' },
  { nr: 10, name: 'Übergabe' },
]

function getDiff(wunschdatum) {
  if (!wunschdatum) return null
  return Math.floor((new Date(wunschdatum) - new Date()) / 86400000)
}

function cardBg(f) {
  if (f.fastcars) return '#faf5ff'
  if (f.problem)  return '#fff5f5'
  if (!f.wunschdatum) return '#fff'
  const diff = getDiff(f.wunschdatum)
  if (diff < 0)   return '#fff5f5'
  if (diff === 0) return '#fff5f5'
  if (diff <= 1)  return '#fffbeb'
  return '#fff'
}

function cardBorder(f) {
  if (f.fastcars) return '3px solid #7c3aed'
  if (f.problem)  return '3px solid #ef4444'
  if (!f.wunschdatum) return '3px solid #e5e7eb'
  const diff = getDiff(f.wunschdatum)
  if (diff < 0)   return '3px solid #c53030'
  if (diff === 0) return '3px solid #ef4444'
  if (diff <= 1)  return '3px solid #f59e0b'
  return '3px solid #22c55e'
}

/* ── Tablet Tracker Modal ── */
function TabletTracker({ fahrzeug, mitarbeiter, onClose, onAdvanced }) {
  const [loading, setLoading]           = useState(false)
  const [notiz, setNotiz]               = useState('')
  const [kuerzel, setKuerzel]           = useState('')
  const [übergabeOk, setÜbergabeOk]    = useState(false)
  const [übergabeDatum, setÜbergabeDatum] = useState(new Date().toISOString().split('T')[0])
  const [current, setCurrent]           = useState(fahrzeug)

  useEffect(() => {
    const channel = supabase
      .channel(`tablet-fahrzeug-${fahrzeug.id}`)
      .on('postgres_changes', { event: '*', schema: 'public', table: 'fahrzeuge', filter: `id=eq.${fahrzeug.id}` },
        (payload) => setCurrent(payload.new))
      .subscribe()
    return () => supabase.removeChannel(channel)
  }, [fahrzeug.id])

  const log = async (schritt, typ, text) => {
    await supabase.from('schritt_historie').insert({ fahrzeug_id: fahrzeug.id, schritt, typ, text, mitarbeiter })
  }

  const weiter = async () => {
    if (loading) return
    const schritt = current.schritt

    if (schritt === 10) {
      if (!übergabeOk) { alert('Bitte Übergabe bestätigen!'); return }
      setLoading(true)
      await supabase.from('fahrzeuge').update({ übergabe_ok: true, übergabe_datum: übergabeDatum }).eq('id', fahrzeug.id)
      await log(10, 'übergabe', `✅ Übergeben am ${new Date(übergabeDatum).toLocaleDateString('de-DE')}`)
      if (notiz) await log(10, 'notiz', `📝 ${notiz}`)
      setLoading(false)
      onAdvanced()
      return
    }

    const update = { schritt: schritt + 1, problem: false }
    if (schritt === 3 && kuerzel) update.mitarbeiter = kuerzel
    setLoading(true)
    await supabase.from('fahrzeuge').update(update).eq('id', fahrzeug.id)
    const schrittName = SCHRITTE[schritt - 1]?.name || `Schritt ${schritt}`
    await log(schritt, 'schritt', `✓ ${schrittName} abgeschlossen${kuerzel ? ` [${kuerzel}]` : ''}`)
    if (notiz) await log(schritt, 'notiz', `📝 ${notiz}`)
    setLoading(false)
    onAdvanced()
  }

  const schritt = current.schritt
  const naechster = schritt < 10 ? SCHRITTE[schritt]?.name : null

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300, padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 24, width: '100%', maxWidth: 440, boxShadow: '0 12px 40px rgba(0,0,0,0.25)', maxHeight: '90vh', overflowY: 'auto' }}>

        {/* Header */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 26, fontWeight: 900, color: '#111', letterSpacing: 0.5 }}>{current.kennzeichen}</div>
          <div style={{ fontSize: 14, color: '#6b7280', marginTop: 2 }}>{current.marke} {current.modell}</div>
          {current.kunde && <div style={{ fontSize: 14, color: '#374151', marginTop: 2 }}>{current.kunde}</div>}
        </div>

        {/* Progress Dots */}
        <div style={{ display: 'flex', gap: 4, marginBottom: 16, justifyContent: 'center' }}>
          {SCHRITTE.map(s => (
            <div key={s.nr} style={{
              width: s.nr === schritt ? 28 : 20, height: 20, borderRadius: 10,
              background: s.nr < schritt ? '#22c55e' : s.nr === schritt ? '#ffc000' : '#e5e7eb',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              transition: 'all 0.2s',
            }}>
              {s.nr === schritt && <span style={{ fontSize: 10, color: '#111111', fontWeight: 800 }}>{s.nr}</span>}
            </div>
          ))}
        </div>

        {/* Current Step */}
        <div style={{ background: '#f8fafc', borderRadius: 10, padding: '12px 16px', marginBottom: 16, textAlign: 'center' }}>
          <div style={{ fontSize: 12, color: '#9ca3af', marginBottom: 2 }}>Aktueller Schritt</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#0d1b2a' }}>
            {schritt} · {SCHRITTE[schritt - 1]?.name}
          </div>
          {naechster && (
            <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 4 }}>Weiter → {naechster}</div>
          )}
        </div>

        {/* Kürzel (Schritt 3 only) */}
        {schritt === 3 && (
          <div style={{ marginBottom: 14 }}>
            <label style={lbl}>Mitarbeiter-Kürzel</label>
            <input
              style={inp}
              placeholder="z.B. JS"
              maxLength={4}
              value={kuerzel}
              onChange={e => setKuerzel(e.target.value.toUpperCase())}
              autoComplete="off"
            />
          </div>
        )}

        {/* Übergabe (Schritt 10) */}
        {schritt === 10 && (
          <div style={{ marginBottom: 14 }}>
            <label style={lbl}>Übergabedatum</label>
            <input type="date" style={inp} value={übergabeDatum} onChange={e => setÜbergabeDatum(e.target.value)} />
            <label style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 12, cursor: 'pointer', fontSize: 16, fontWeight: 600 }}>
              <input type="checkbox" checked={übergabeOk} onChange={e => setÜbergabeOk(e.target.checked)} style={{ width: 22, height: 22 }} />
              Übergabe bestätigen
            </label>
          </div>
        )}

        {/* Notiz */}
        <div style={{ marginBottom: 20 }}>
          <label style={lbl}>Notiz (optional)</label>
          <textarea
            style={{ ...inp, height: 80, resize: 'none', fontFamily: 'inherit' }}
            placeholder="Anmerkung zum Schritt..."
            value={notiz}
            onChange={e => setNotiz(e.target.value)}
          />
        </div>

        {/* Buttons */}
        <button
          onClick={weiter}
          disabled={loading}
          style={{
            width: '100%', height: 56, border: 'none', borderRadius: 12,
            background: loading ? '#9ca3af' : schritt === 10 ? '#16a34a' : '#ffc000',
            color: loading || schritt === 10 ? '#fff' : '#111111', fontSize: 17, fontWeight: 800,
            cursor: loading ? 'not-allowed' : 'pointer',
            marginBottom: 10,
          }}>
          {loading ? 'Speichern...' : schritt === 10 ? '✓ Übergabe abschließen' : `Weiter zu Schritt ${schritt + 1} →`}
        </button>

        <button
          onClick={onClose}
          disabled={loading}
          style={{
            width: '100%', height: 48, border: '1.5px solid #e5e7eb', borderRadius: 12,
            background: '#fff', color: '#6b7280', fontSize: 15, fontWeight: 600,
            cursor: 'pointer',
          }}>
          Abbrechen
        </button>
      </div>
    </div>
  )
}

/* ── Login Form ── */
function TabletLogin({ onLogin }) {
  const [email, setEmail]       = useState('')
  const [password, setPassword] = useState('')
  const [error, setError]       = useState('')
  const [loading, setLoading]   = useState(false)

  const login = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    const { error: err } = await supabase.auth.signInWithPassword({ email, password })
    if (err) { setError(err.message); setLoading(false) }
    else     { onLogin() }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0d1b2a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 20, padding: '36px 32px', width: '100%', maxWidth: 380, boxShadow: '0 20px 60px rgba(0,0,0,0.4)' }}>
        <div style={{ fontSize: 22, fontWeight: 900, color: '#0d1b2a', marginBottom: 6, textAlign: 'center' }}>WerkstattBoard</div>
        <div style={{ fontSize: 14, color: '#9ca3af', marginBottom: 28, textAlign: 'center' }}>Tablet-Modus · Anmelden</div>
        <form onSubmit={login}>
          <div style={{ marginBottom: 16 }}>
            <label style={lbl}>E-Mail</label>
            <input style={inp} type="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" autoCapitalize="none" required />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={lbl}>Passwort</label>
            <input style={inp} type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" required />
          </div>
          {error && <div style={{ background: '#fff5f5', color: '#c53030', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 13 }}>⚠ {error}</div>}
          <button type="submit" disabled={loading} style={{
            width: '100%', height: 52, border: 'none', borderRadius: 12,
            background: loading ? '#9ca3af' : '#0d1b2a', color: '#fff',
            fontSize: 16, fontWeight: 800, cursor: loading ? 'not-allowed' : 'pointer',
          }}>
            {loading ? 'Anmelden...' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  )
}

/* ── Main TabletView ── */
export default function TabletView() {
  const [session, setSession]     = useState(null)
  const [checking, setChecking]   = useState(true)
  const [fahrzeuge, setFahrzeuge] = useState([])
  const [selected, setSelected]   = useState(null)
  const [mitarbeiter, setMitarbeiter] = useState('')

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session: s } }) => {
      setSession(s)
      if (s) { setMitarbeiter(s.user.email); loadFahrzeuge() }
      setChecking(false)
    })
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, s) => {
      setSession(s)
      if (s) { setMitarbeiter(s.user.email); loadFahrzeuge() }
    })
    return () => subscription.unsubscribe()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!session) return
    const channel = supabase
      .channel('tablet-realtime')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'fahrzeuge' }, () => loadFahrzeuge())
      .subscribe()
    return () => supabase.removeChannel(channel)
  }, [session])

  const loadFahrzeuge = async () => {
    const { data } = await supabase
      .from('fahrzeuge').select('*').is('übergabe_ok', null)
      .order('wunschdatum', { ascending: true, nullsFirst: false })
    setFahrzeuge(data || [])
  }

  const handleAdvanced = () => {
    setSelected(null)
    loadFahrzeuge()
  }

  if (checking) {
    return (
      <div style={{ minHeight: '100vh', background: '#0d1b2a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ color: '#fff', fontSize: 16 }}>Laden...</div>
      </div>
    )
  }

  if (!session) {
    return <TabletLogin onLogin={() => supabase.auth.getSession().then(({ data: { session: s } }) => {
      setSession(s)
      if (s) { setMitarbeiter(s.user.email); loadFahrzeuge() }
    })} />
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f3f4f6', fontFamily: 'system-ui, sans-serif' }}>

      {/* Header */}
      <div style={{ background: '#0d1b2a', padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <div style={{ fontSize: 15, fontWeight: 800, color: '#fff' }}>WerkstattBoard</div>
          <div style={{ fontSize: 11, color: '#9ca3af' }}>Tablet-Modus · {fahrzeuge.length} Fahrzeuge</div>
        </div>
        <button onClick={() => supabase.auth.signOut()}
          style={{ background: 'none', color: '#9ca3af', border: '1px solid #444', borderRadius: 8, padding: '6px 12px', cursor: 'pointer', fontSize: 12 }}>
          Abmelden
        </button>
      </div>

      {/* Car Grid */}
      <div style={{ padding: 12, display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 10 }}>
        {fahrzeuge.length === 0 && (
          <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: 48, color: '#9ca3af', fontSize: 15 }}>
            Keine aktiven Fahrzeuge
          </div>
        )}
        {fahrzeuge.map(f => {
          const tage = Math.floor((new Date() - new Date(f.eingang)) / 86400000)
          const diff = getDiff(f.wunschdatum)
          const schrittName = SCHRITTE[f.schritt - 1]?.name || `Schritt ${f.schritt}`
          return (
            <div key={f.id}
              onClick={() => setSelected(f)}
              style={{
                background: cardBg(f),
                borderLeft: cardBorder(f),
                borderTop: '1px solid #e5e7eb',
                borderRight: '1px solid #e5e7eb',
                borderBottom: '1px solid #e5e7eb',
                borderRadius: 12, padding: '14px 12px',
                cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                userSelect: 'none',
              }}>
              <div style={{ fontSize: 18, fontWeight: 900, color: '#111', marginBottom: 3 }}>{f.kennzeichen}</div>
              <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 6 }}>{f.marke} {f.modell}</div>

              <div style={{ background: '#0d1b2a', color: '#fff', borderRadius: 6, padding: '4px 8px', marginBottom: 6, display: 'inline-block' }}>
                <span style={{ fontSize: 11, fontWeight: 700 }}>{f.schritt} · {schrittName}</span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 4 }}>
                <span style={{ fontSize: 11, color: '#9ca3af' }}>{tage}d im Betrieb</span>
                {diff !== null && (
                  <span style={{ fontSize: 10, fontWeight: 700, color: diff < 0 ? '#c53030' : diff <= 1 ? '#d97706' : '#22c55e' }}>
                    {diff < 0 ? `${Math.abs(diff)}T über` : diff === 0 ? 'Heute!' : `${diff}T`}
                  </span>
                )}
              </div>

              {f.problem && <div style={{ marginTop: 4, fontSize: 10, color: '#ef4444', fontWeight: 700 }}>⚠ Problem</div>}
              {f.fastcars && <div style={{ marginTop: 4, fontSize: 10, color: '#7c3aed', fontWeight: 700 }}>🔧 FastCars</div>}
            </div>
          )
        })}
      </div>

      {selected && (
        <TabletTracker
          fahrzeug={selected}
          mitarbeiter={mitarbeiter}
          onClose={() => setSelected(null)}
          onAdvanced={handleAdvanced}
        />
      )}
    </div>
  )
}

const lbl = { display: 'block', fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 6 }
const inp = { width: '100%', padding: '12px 14px', border: '1.5px solid #d1d5db', borderRadius: 10, fontSize: 16, boxSizing: 'border-box', outline: 'none' }
